/**
 * Temizlenen alanlar için AntD `undefined` üretir, JSON.stringify de onları
 * gövdeden düşürür; PATCH'te alan gitmeyince eski değer korunur. Bu yüzden
 * temizlenen alanlar açıkça `null` gönderilir.
 */
export const normalizeTagValues = (values: any) => {
  const superCategoryId = values?.superCategory?.id;

  return {
    ...values,
    superCategory: superCategoryId ? { id: superCategoryId } : null,
    superCategoryOrder: superCategoryId
      ? values?.superCategoryOrder ?? null
      : null,
  };
};
